const routes = [
  {
    path: 'textshadow',
    name: 'textshadow',
    component: () => import(/* webpackChunkName: "textshadow" */ '@/modules/textshadow/index.vue')
  },
];

export default routes;